export default __webpack_public_path__ + "static/media/ds-praticando-prog-js.6c7388a3.png";